import React, {useReducer} from "react";
import {connect} from "react-redux";

import {LOOK_OVERLAYS} from "../../../look/core/constants";
import LookAiPopupContext, {lookAiPopupContextReducer} from "./LookAiPopupContext";
import LookAIPopupContent from "./LookAIPopupContent";
import LookAIPopupGenerateButton from "./LookAIPopupGenerateButton";
import LookAIImageOverlay from "../lookAIOverlays/LookAIImageOverlay";
import LookAIImagesOverlay from "../lookAIOverlays/LookAIImagesOverlay";
import LookAIWaitingBox from "../lookAIOverlays/LookAIWaitingBox";
import {IS_QKB_UI} from "../../../../config";
import LookAITutorial from "../lookAITutorial/LookAITutorial";
import LookAILoadingPanel from "../lookAIOverlays/LookAILoadingPanel";


const LookAIPopup = (props) => {

  const {lookOverlayOpened, lookAiVisited, fabricatorData, isMobile, isPhoneNumberValidated, aiResults, aiImageExpanded} = props;

  const [lookAiPopupContext, lookAiPopupDispatch] = useReducer(lookAiPopupContextReducer, {});

  if (!fabricatorData.aiSettings.enableAI) {
    return null;
  }

  const showLeadOverlay = !isPhoneNumberValidated && !document.kvConfig.isBackend;
  const showImagesListOverlay = (aiResults.filter(res => res.resultImageUrl)).length > 1;

  return (
    <LookAiPopupContext.Provider value={{lookAiPopupContext, lookAiPopupDispatch}}>
      <LookAIImagesOverlay showLeadOverlay={showLeadOverlay} showImagesListOverlay={showImagesListOverlay}/>
      <LookAIImageOverlay showLeadOverlay={showLeadOverlay} showImagesListOverlay={showImagesListOverlay}/>
      <div className={"fixed transition2 h-full left-0 top-0 look-ai__panel flex flex--column"
        + (lookOverlayOpened === LOOK_OVERLAYS.aiPanel
        && !(isMobile && showLeadOverlay && aiResults.some(res => res.resultImageUrl))
        && !aiImageExpanded ? " look-ai__panel--opened" : "")
        + (IS_QKB_UI ? " pl-0 look-ai__panel--qkb look-icon--with-shadow" : "")}>
        {lookAiVisited ? <LookAIPopupContent showLeadOverlay={showLeadOverlay}/> : null}
        {lookAiVisited ? <LookAIPopupGenerateButton showLeadOverlay={showLeadOverlay}/> : null}
      </div>
      <LookAIWaitingBox/>
      <LookAILoadingPanel/>
      {document.kvConfig.isBackend || IS_QKB_UI ? null : <LookAITutorial/>}
    </LookAiPopupContext.Provider>
  )
};

const mapStateToProps = (store) => {
  const {lookOverlayOpened} = store.lookState;
  const {lookAiVisited, aiResults, aiImageExpanded} = store.aiState;
  const {isPhoneNumberValidated} = store.userState;
  const {isMobile} = store.serverState;

  return {
    lookOverlayOpened,
    lookAiVisited,
    fabricatorData: store.fabricatorState,
    isPhoneNumberValidated,
    isMobile,
    aiResults,
    aiImageExpanded,
  };
};

export default connect(mapStateToProps)(LookAIPopup)
